import { Link, useLocation } from "react-router-dom";
import hewlett from "../../assests/HPE/Landing-page/hpe-cloud/logo.svg";
import zertoLogo from "../../assests/HPE/zerto/logo.svg";

const ZertoHeader = () => {
  const location = useLocation(); // gives current URL path

  // Map routes to logos (texts in this case)
  // const logos = {
  //   "/": { text: "Hybrid cloud software portfolio", link: "/" },
  //   "/thank-you": { text: "Hybrid cloud software portfolio", link: "/" },
  //   "/zerto": { text: "hpe zerto software", link: "/zerto" },
  //   "/zerto/thank-you": { text: "hpe zerto software", link: "/zerto" },
  // };

  // // Default to "title" if route not listed
  // const { text: logoText, link: logoLink } = logos[location.pathname] || {
  //   text: "HPE CLOUD SOFTWARE PORTFOLIO",
  //   link: "/",
  // };

  const logos = {
    "/": { text: "Hybrid cloud software portfolio", link: "/", logo: hewlett },
    "/thank-you": {
      text: "Hybrid cloud software portfolio",
      link: "/",
      logo: hewlett,
    },
    "/zerto": { text: "hpe zerto software", link: "/zerto", logo: zertoLogo },
    "/zerto/thank-you": {
      text: "hpe zerto software",
      link: "/zerto",
      logo: zertoLogo,
    },
  };

  // Default to "title" if route not listed
  const { link: logoLink, logo } = logos[location.pathname] || {
    text: "HPE CLOUD SOFTWARE PORTFOLIO",
    link: "/",
  };

  return (
    <header className="absolute top-0 left-0 w-full z-20">
      <div className="bg-white flex flex-col gap-2">
        <div className="py-3 md:py-6 px-4 md:px-16 flex gap-6 items-center justify-center">
          <Link to={"/hpe-zerto-software"}>
            <img src={zertoLogo} alt="hewlett" className="max-h-5 md:max-h-6" />
          </Link>
          {/* <div className="flex items-center justify-center">
            <Link
              to={logoLink}
              className="flex items-center justify-center gap-x-5"
            >
              <span className="text-grey-06 uppercase">{logoText}</span>
            </Link>
          </div> */}
        </div>
      </div>
    </header>
  );
};

export default ZertoHeader;
